export default "__VITE_ASSET__18ff232a__"